module.exports = __webpack_public_path__ + "img/zy_complete.4263b271.png";